import { useEffect } from 'react';

import { CheckedIcon } from 'components/Icon';

import styles from './SetMembershipPrice.Success.module.scss';

export type SuccessProps = {
  onProceed?(): void;
};

const Success = ({ onProceed }: SuccessProps) => {
  useEffect(() => {
    const redirectTimeout = setTimeout(() => {
      onProceed?.();
    }, 3_000);

    return () => {
      clearTimeout(redirectTimeout);
    };
  }, []);

  return (
    <div className={styles.container}>
      <CheckedIcon />
      <h3>Congrats! Your price is set</h3>
      <p>You will be redirected to the homepage in 3 seconds...</p>
    </div>
  );
};

export default Success;
